/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CommunityMetadataCommunityManager
 */
export interface CommunityMetadataCommunityManager {
    /**
     * 
     * @type {string}
     * @memberof CommunityMetadataCommunityManager
     */
    fullName: string;
}

/**
 * Check if a given object implements the CommunityMetadataCommunityManager interface.
 */
export function instanceOfCommunityMetadataCommunityManager(value: object): value is CommunityMetadataCommunityManager {
    if (!('fullName' in value) || value['fullName'] === undefined) return false;
    return true;
}

export function CommunityMetadataCommunityManagerFromJSON(json: any): CommunityMetadataCommunityManager {
    return CommunityMetadataCommunityManagerFromJSONTyped(json, false);
}

export function CommunityMetadataCommunityManagerFromJSONTyped(json: any, ignoreDiscriminator: boolean): CommunityMetadataCommunityManager {
    if (json == null) {
        return json;
    }
    return {
        
        'fullName': json['fullName'],
    };
}

export function CommunityMetadataCommunityManagerToJSON(value?: CommunityMetadataCommunityManager | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'fullName': value['fullName'],
    };
}

